// extracted by css-extract-rspack-plugin
module.exports =  {"deadlineCalendar":"UpdateDeadlineDialog__deadlineCalendar___alkB7"};